module.exports = __webpack_public_path__ + "static/media/detail_0040_t.7214f21d.jpg";